// Touching `env` runs its required-var asserts as a side effect. This step
// exists so bootstrap fails *before* any plugin init when a deploy is missing
// configuration — the trace blames a missing env var, not a downstream null.

import { config } from '@core/config'
import { logger } from '@core/logging/logger'

export const initEnv = (): void => {
  // Read a value so the lazy property accessors fire.
  logger.debug('env initialised', { appEnv: config.appEnv, logLevel: config.logLevel })
}
